import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'any',
})
export class ContentLoaderService {
  private _loader: boolean;
  public get loader(): boolean {
    return this._loader;
  }
  public set loader(value: boolean) {
    this._loader = value;
  }

  constructor() {
    this._loader = false;
  }
}
